export default __webpack_public_path__ + "static/media/fb2AF.db177b17.png";